<template>
  <div class="seaFreightDataStatistics">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1" v-if="menuState == 2">
          <div class="custom-date" v-if="searchType == 1">
            <div class="date-btn1" @click="showStartDate">
              <span v-if="beginTime">{{ beginTime }}</span>
              <span v-else>{{ $t.meta.beginDate }}</span>
            </div>
            <div class="date-btn2" @click="showEndDate">
              <span v-if="endTime">{{ endTime }}</span>
              <span v-else>{{ $t.meta.endDate }}</span>
            </div>
            <van-button size="small" type="info" @click="onSearch">{{
              $t.meta.search
            }}</van-button>
          </div>
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="$t.meta.searchText"
            v-else-if="searchType == 2 || searchType == 3"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
          <van-field
            readonly
            :value="deliveryCityName"
            :placeholder="$t.meta.select"
            @click-input="onShowEmit('seaFreightDataStatisticsDeliveryCity')"
            v-else-if="searchType == 4"
          >
            <template #button>
              <van-button size="small" type="info" @click="onSearch">{{
                $t.meta.search
              }}</van-button>
            </template>
          </van-field>
          <van-field
            readonly
            :value="receiveCityName"
            :placeholder="$t.meta.select"
            @click-input="onShowEmit('seaFreightDataStatisticsReceiveCity')"
            v-else-if="searchType == 5"
          >
            <template #button>
              <van-button size="small" type="info" @click="onSearch">{{
                $t.meta.search
              }}</van-button>
            </template>
          </van-field>
        </van-col>
        <van-col class="colItem1" v-else>
          <div class="custom-date" v-if="searchType == 1">
            <div class="date-btn1" @click="showStartDate">
              <span v-if="beginTime">{{ beginTime }}</span>
              <span v-else>{{ $t.meta.beginDate }}</span>
            </div>
            <div class="date-btn2" @click="showEndDate">
              <span v-if="endTime">{{ endTime }}</span>
              <span v-else>{{ $t.meta.endDate }}</span>
            </div>
            <van-button size="small" type="info" @click="onSearch">{{
              $t.meta.search
            }}</van-button>
          </div>
          <van-field
            readonly
            :value="countryName"
            :placeholder="$t.meta.select"
            @click-input="onShowEmit('seaFreightDataStatisticsCountry')"
            v-else-if="searchType == 2"
          >
            <template #button>
              <van-button size="small" type="info" @click="onSearch">{{
                $t.meta.search
              }}</van-button>
            </template>
          </van-field>
          <van-field
            readonly
            :value="cityName"
            :placeholder="$t.meta.select"
            @click-input="onShowEmit('seaFreightDataStatisticsCity')"
            v-else-if="searchType == 3"
          >
            <template #button>
              <van-button size="small" type="info" @click="onSearch">{{
                $t.meta.search
              }}</van-button>
            </template>
          </van-field>
          <van-field
            readonly
            :value="billName"
            :placeholder="$t.meta.select"
            @click-input="onShowEmit('seaFreightDataStatisticsBill')"
            v-else-if="searchType == 4"
          >
            <template #button>
              <van-button size="small" type="info" @click="onSearch">{{
                $t.meta.search
              }}</van-button>
            </template>
          </van-field>
        </van-col>
        <van-col class="colItem2">
          <div @click="handleSheetShow">
            <span>{{ searchTypeStr }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-tabs
      v-model="menuState"
      @change="stateChanged"
      title-active-color="#009ed4"
      color="#009ed4"
      swipeable
    >
      <van-tab
        v-for="(menu, index) in menuList"
        :key="index"
        :title="menu.title + (menu.count > 0 ? ' ' + menu.count : '')"
        :name="menu.name"
        :disabled="loading ? true : false"
      >
        <van-list
          class="list"
          v-model="loading"
          :finished="finished"
          :finished-text="$t.meta.noMore"
          :error.sync="error"
          :error-text="errorText"
          @load="getList(page + 1)"
        >
          <div
            class="list-container"
            v-for="(item, index) in tableData"
            :key="index"
            @click="gotoDetail(item)"
          >
            <template v-if="menuState == 1">
              <div class="list-item">
                {{ $t.seaFreightDataStatistics.month }}：{{ item.Month }}
              </div>
              <div class="list-item">
                {{ $t.seaFreightDataStatistics.wayBillCount }}：{{ item.WayBillCount }}
              </div>
              <div class="list-item">
                {{ $t.seaFreightDataStatistics.costBillCount }}：{{ item.CostBillCount }}
              </div>
            </template>
            <template v-if="menuState == 2">
              <div class="list-item">
                {{ $t.seaFreightDataStatistics.mainWbNumber }}：{{ item.PWB_Number }}
              </div>
              <div class="list-item">
                {{ $t.seaFreightDataStatistics.sideWbNumber }}：{{ item.WB_Number }}
              </div>
              <div class="list-item">
                {{ $t.seaFreightDataStatistics.deliveryPort }}：{{ item.DeliveryCode }}
              </div>
              <div class="list-item">
                {{ $t.seaFreightDataStatistics.destinationPort }}：{{ item.ReceiveCode }}
              </div>
            </template>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>

    <van-popup v-model="showStartPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.beginDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'start')"
        @cancel="showStartPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showEndPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.endDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'end')"
        @cancel="showEndPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <option-list
      event="seaFreightDataStatisticsCountry"
      :options="countryList"
      @onSelect="onSelectCountry"
    ></option-list>

    <option-list
      event="seaFreightDataStatisticsCity"
      :options="cityList"
      @onSelect="onSelectCity"
    ></option-list>

    <option-list
      event="seaFreightDataStatisticsBill"
      :options="billPaymentList"
      @onSelect="onSelectBill"
    ></option-list>

    <option-list
      event="seaFreightDataStatisticsDeliveryCity"
      :options="cityList"
      @onSelect="onSelectDeliveryCity"
    ></option-list>

    <option-list
      event="seaFreightDataStatisticsReceiveCity"
      :options="cityList"
      @onSelect="onSelectReceiveCity"
    ></option-list>

    <van-action-sheet
      :title="$t.meta.searchType"
      :closeable="false"
      v-model="sheetShow"
      :actions="sheetActions"
      @select="sheetSelect"
    />
  </div>
</template>

<script>
import {
  List,
  Row,
  Col,
  Search,
  Button,
  Form,
  Field,
  ActionSheet,
  Popup,
  Picker,
  DatetimePicker,
  Tab,
  Tabs,
} from "vant";

import Vue from "vue";
import OptionList from "@components/optionList/OptionList.vue";
Vue.use(List)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(ActionSheet)
  .use(Popup)
  .use(Picker)
  .use(DatetimePicker)
  .use(Tab)
  .use(Tabs);

export default {
  name: "seaFreightDataStatistics",
  components: {
    OptionList,
  },
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      menuState: this.$route.query.state
        ? this.$route.query.state
        : parseInt(localStorage.getItem("MenuState")),
      menuList: [
        {
          title: this.$t.seaFreightDataStatistics.tab1,
          name: 1,
          count: 0,
        },
        {
          title: this.$t.seaFreightDataStatistics.tab2,
          name: 2,
          count: 0,
        },
      ],
      page: 0,
      pageSize: 10,
      tableData: [],
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //filter
      searchType: 1,
      searchTypeStr: this.$t.seaFreightDataStatistics.date,
      searchText: "",
      countryName: "",
      countryId: null,
      cityName: "",
      cityId: null,
      billName: "",
      billId: null,
      deliveryCityName: "",
      deliveryCityId: null,
      receiveCityName: "",
      receiveCityId: null,
      //日期
      selectDate: new Date(),
      currentDate: "",
      showStartPicker: false,
      beginTime: "",
      showEndPicker: false,
      endTime: "",
      //操作菜单
      sheetShow: false,
      sheetActions: [],
      countryList: [],
      cityList: [],
      billPaymentList: [],
    };
  },
  watch: {
    menuState() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
      this.getList(1);
    },
  },
  created() {
    this.getOptions();
    this.defaultDate();
  },
  methods: {
    onShowEmit(emit) {
      this.$bus.$emit(emit, true);
    },
    onSelectCountry(item) {
      this.countryName = item.text;
      this.countryId = item.value;
    },
    onSelectCity(item) {
      this.cityName = item.text;
      this.cityId = item.value;
    },
    onSelectBill(item) {
      this.billName = item.text;
      this.billId = item.value;
    },
    onSelectDeliveryCity(item) {
      this.deliveryCityName = item.text;
      this.deliveryCityId = item.value;
    },
    onSelectReceiveCity(item) {
      this.receiveCityName = item.text;
      this.receiveCityId = item.value;
    },
    sheetSelect(e) {
      this.searchTypeStr = e.name;
      this.searchType = e.className;
      this.sheetShow = false;
    },
    handleSheetShow() {
      var actions = [];
      if (this.menuState == 2) {
        actions = [
          { name: this.$t.seaFreightDataStatistics.date, className: "1" },
          {
            name: this.$t.seaFreightDataStatistics.mainWbNumber,
            className: "2",
          },
          {
            name: this.$t.seaFreightDataStatistics.sideWbNumber,
            className: "3",
          },
          {
            name: this.$t.seaFreightDataStatistics.deliveryCity,
            className: "4",
          },
          {
            name: this.$t.seaFreightDataStatistics.receiveCity,
            className: "5",
          },
        ];
      } else {
        actions = [
          { name: this.$t.seaFreightDataStatistics.date, className: "1" },
          {
            name: this.$t.seaFreightDataStatistics.receiveCountry,
            className: "2",
          },
          {
            name: this.$t.seaFreightDataStatistics.receiveCity,
            className: "3",
          },
          { name: this.$t.seaFreightDataStatistics.billName, className: "4" },
        ];
      }
      this.sheetActions = actions;
      this.sheetShow = true;
    },
    defaultDate() {
      let date = new Date();
      let year = date.getFullYear().toString();
      let beg = year + "-01" + "-01";
      let end = year + "-12" + "-31";
      this.beginTime = beg;
      this.endTime = end;
    },
    gotoDetail(item) {
      var data = item;
      data.menuState = this.menuState;
      localStorage.setItem("seaFreightDataStatisticsDetail", JSON.stringify(data));
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "seaFreightDataStatisticsDetail",
        name: "seaFreightDataStatisticsDetail",
        query: [],
      });
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
    },
    showStartDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showStartPicker = true;
    },
    showEndDate() {
      var end = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = end;
      this.showEndPicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date, type) {
      var formatDate = (val) => {
        var time = new Date(val).toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      if (type == "start") {
        this.beginTime = formatDate(date);
        this.showStartPicker = false;
      }
      if (type == "end") {
        this.endTime = formatDate(date);
        this.showEndPicker = false;
      }
    },
    stateChanged(state) {
      this.menuState = state;
      localStorage.setItem("MenuState", JSON.stringify(state));
      if (state == 2) {
        this.beginTime = "";
        this.endTime = "";
      } else {
        this.defaultDate();
      }
      this.searchType = 1;
      this.searchTypeStr = this.$t.seaFreightDataStatistics.date;
    },
    getList(page) {
      var param = {
        BeginTime: this.beginTime,
        EndTime: this.endTime,
      };
      var request = null;
      if (this.menuState == 2) {
        param.PageIndex = page;
        param.PageSize = this.pageSize;
        param.PWB_Number = this.searchType == 2 ? this.searchText : "";
        param.WB_Number = this.searchType == 3 ? this.searchText : "";
        param.DeliveryCityId = this.searchType == 4 ? this.deliveryCityId : null;
        param.ReceiveCityId = this.searchType == 5 ? this.receiveCityId : null;
        request = this.$api.dataSummary.getCargoPortInquiryList(param);
      } else {
        param.CountryId = this.searchType == 2 ? this.countryId : null;
        param.CityId = this.searchType == 3 ? this.cityId : null;
        param.BillId = this.searchType == 4 ? this.billId : null;
        request = this.$api.dataSummary.seaTransportationMonthBillStatistics(param);
      }
      request
        .then((res) => {
          if (this.menuState == 2) {
            this.tableData = this.tableData.concat(res.data.Data);
          } else {
            this.tableData = res.data;
          }
          this.loading = false;
          this.error = false;
          this.errorText = "";

          if (this.menuState == 1) {
            this.finished = true;
          } else {
            this.page = res.meta.page;
            this.finished = this.page >= res.meta.lastPage;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
    getOptions() {
      return new Promise((resolve) => {
        Promise.all([
          this.getBillPaymentList(),
          this.getCountryList(),
          this.getCityList(),
        ]).then((success) => {
          if (success) resolve(true);
        });
      });
    },
    getBillPaymentList() {
      return new Promise((resolve) => {
        this.$api.financialManagement
          .getBillPaymentListByCompanyId()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.ItemName,
                value: item.BillId,
              };
              result.push(data);
            });
            this.billPaymentList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getCountryList() {
      this.$api.customerManagement
        .getCountryList()
        .then((res) => {
          var result = [];
          res.data.forEach((item) => {
            let data = {
              text: item.CountryName + "," + item.CountryName_en,
              value: item.CountryId,
            };
            result.push(data);
          });
          this.countryList = result;
        })
        .catch((error) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    getCityList() {
      this.$api.logisticsManagement
        .getCountryList({
          type: 1,
        })
        .then((res) => {
          var result = [];
          res.data.forEach((item) => {
            let data = {
              text: item.City_cn + "," + item.City_en,
              value: item.Id,
            };
            result.push(data);
          });
          this.cityList = result;
        })
        .catch((error) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.seaFreightDataStatistics {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;
        .van-search__content {
          .van-cell {
            padding: 5px 8px 5px 0;
          }
        }
        .van-cell {
          padding: 10px 0px 10px 20px;
        }
        .custom-date {
          padding: 10px 0px 10px 0px;
          .date-btn1 {
            width: 40%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
          }
          .date-btn2 {
            width: 40%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
          }
          .van-button {
            vertical-align: middle;
            width: 18%;
            .van-button__text {
              font-size: 14px !important;
            }
          }
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 12px;
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
      }
      .list-item:last-child {
        margin-bottom: 0px;
      }
      .buttons {
        text-align: right;
        padding-bottom: 10px;
        .primary-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .default-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .search-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .danger-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio-group {
    margin-bottom: 20px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;
    .van-cell:after {
      border: none;
    }
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
    .custom-date {
      text-align: center;
      border-bottom: 1px solid #ebedf0;
      padding-bottom: 20px;
      .date-label {
        text-align: left;
        font-size: 14px;
        color: #646566;
        margin-left: 15px;
        margin-bottom: 10px;
        margin-top: 10px;
      }
      .date-btn1 {
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-btn2 {
        margin-left: 30px;
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-txt {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
        border-radius: 10px;
      }
    }
  }
  .popup-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    border-top: 1px solid #f6f6f6;
    .tool-button {
      align-items: center;
    }
  }
}
</style>
